module.exports = __webpack_public_path__ + "static/media/ol.b852aea2.svg";